import React, { useCallback, useMemo, useState } from 'react';

import { useStyles } from './style';
import Add from '@material-ui/icons/Add';
import { Box, Typography } from '@material-ui/core';
import { useGetPaymentMethodsQuery } from '../../../../api/payment-method';
import { OpLoading } from '../../../../shared/components/op-loading';
import { PaymentItem } from './PaymentItem';
import { PaymentForm } from './PaymentForm';
import { ChevronLeft } from '@material-ui/icons';
import { PaymentMethodDetail } from './PaymentMethodDetail';
import { PaymentMethod } from '../../../../api/payment-method/types';
import { RetryPayment } from '../Retry-Payment';
import { useMeQuery } from '../../../../api/user';

export const SupplierPayment: React.FC = () => {
  const classes = useStyles();
  const {data: paymentMethods, isLoading: paymentMethodsLoading } = useGetPaymentMethodsQuery();
  const [step, setStep] = useState(0);
  const [currentPaymentMethod, setCurrentPaymentMethod] = useState<PaymentMethod | null>(null);
  const { data: user } = useMeQuery();

  const isLastPaymentFailed = useMemo(() => {
    return user?.has_payment_error === true;
  }, [user]);

  const isEmptyCard = useMemo(() => {
    return paymentMethods?.payment_methods.length === 0;
  }, [paymentMethods]);

  const onAddNewPaymentClick = useCallback(() => {
    setStep(1);
  }, []);

  const backStep = useCallback(() => {
    setStep(0);
  }, []);

  const onPaymentDetailClick = useCallback((paymentItem: PaymentMethod) => {
    setCurrentPaymentMethod(paymentItem);
    setStep(2);
  }, []);

  return (
    <>
      {isLastPaymentFailed && <RetryPayment />}
      {step === 0 && <>
        <div className={classes.addContainer}>
          <div className={classes.title}>
            Your Payment Methods
          </div>
          <div className={classes.addMethod} onClick={onAddNewPaymentClick}>
            <Add /> ADD PAYMENT METHOD
          </div>
        </div>

        {isEmptyCard && <Typography className={classes.noPayment}>
          No Payment Methods
        </Typography>}

        <OpLoading loading={paymentMethodsLoading} dataLoaded={!paymentMethodsLoading}>
          {paymentMethods?.payment_methods?.map((pm) => (
            <>
            <PaymentItem paymentItem={pm} onPaymentDetailClick={onPaymentDetailClick} />
            </>
          ))}
        </OpLoading>
      </>}

      {step === 1 && <>
        <Box className={classes.backContainer} onClick={backStep}>
          <ChevronLeft className={classes.backChevron} /> Back
        </Box>
        <PaymentForm backStep={backStep} />
      </>}

      {step === 2 && currentPaymentMethod && <>
        <Box className={classes.backContainer} onClick={backStep}>
          <ChevronLeft className={classes.backChevron} /> Back
        </Box>
        <PaymentMethodDetail paymentItem={currentPaymentMethod} backStep={backStep} />
      </>}
    </>
  );
};
